import { ApiFunusQr } from './types';
import axios from 'config/axios';
import { defaultFilter } from '.';

export const qr: ApiFunusQr = {
  getQrs: (params = defaultFilter) => axios.post('/records/qrs', params),
};
